import FiltersBarDesktop from './FiltersBarDesktop';
import { withI18n } from 'react-i18next';
export default withI18n()(FiltersBarDesktop);
